<template>
  <div :class="{['p-question__'+tagPosition]:true}">
    <ul class="helpList">
      <li class="helpPoint" v-if="isPoint">
        <a class="jsPopupButton" @click="emit('click', 'point')" :name="`${pageName}-hint-btn`"><span class="label"><span class="label__text"><small>この項目の</small>ポイント</span></span></a>
      </li>
      <li class="helpHint" v-if="isHint">
        <a class="jsPopupButton" @click="emit('click', 'hint')" :name="`${pageName}-point-btn`"><span class="label"><span class="label__text">ヒント</span></span></a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      tagPosition?: string;
      isHint?: boolean;
      isPoint?: boolean;
      pageName?: string;
    }>(),
    {
      tagPosition: "",
      isHint: false,
      isPoint: false,
      pageName: '',
    }
  );
  const emit = defineEmits<{
    (e: 'click', id: string): void,
  }>()

</script>
